/* eslint-disable camelcase */
import React, { useEffect, useState } from "react"

import { decodeHtmlCharacters } from "@/utils/helper"
import { accordianAnalyticsData } from "@/components/ProductDetail/v3/ProductAccordionList/analytics"
import { getDimensionData } from "@/components/ProductDetail/v3/ProductAccordionList/utils"

import DesignFiles from "@/components/ProductDetail/v3/ProductAccordionList/designFiles"
import InstallationSupport from "@/components/ProductDetail/v3/ProductAccordionList/installationSupport"
import ProductAccordion from "@/components/ProductDetail/v3/ProductAccordionList/productAccordion"
import Features from "@/components/ProductDetail/v3/ProductAccordionList/Features"
import Specs from "@/components/ProductDetail/v3/ProductAccordionList/Specs"
import AddOnService from "@/components/ProductDetail/v3/ProductAccordionList/AddOnService"
import RowData from "@/components/ProductDetail/v3/ProductAccordionList/RowData"

import accordionStyles from "@/components/core/Accordion/Accordion.module.scss"
import styles from "@/components/ProductDetail/v3/ProductAccordionList/index.module.scss"

const ProductAccordionList = props => {
  const {
    productData = {},
    productSku = "",
    productInfo = {},
    isDiscontinued = false,
    persona = "",
    staticTexts = {},
    accordionList = [],
    installationDataFromProp = [],
    designServiceDataFromProp = [],
    disableEcommerce = false,
    isProjectPack = false,
    installationSupportLinks = [],
    productType = "",
    productServices = [],
    dimensionData = {},
    config = {},
  } = props

  const { productAccordionText } = staticTexts
  const defaultExpand = {
    feature: false,
    dimensions: false,
    specs: false,
    designFile: false,
    installationSupport: false,
    addOnService: true,
  }
  const designFiles = {
    twoDimension: {
      plan: [],
      front: [],
      side: [],
    },
    threeDimension: [],
    bim: [],
    cutout: [],
  }
  const techFiles = []
  const installFiles = {
    productId: productData["ProductProductNo_s"] ?? "",
    guides: {
      installationGuides: [],
      supportGuides: [],
    },
    partsLinks: [],
    pdfPartsLinks: [],
    videos: [],
    supportLinks: [],
  }
  const designFileType = {
    twoDimension: [
      { type: "DWG", fromProductData: "DWGPlanView", angleView: "plan" },
      { type: "DXF", fromProductData: "DXFPlanView", angleView: "plan" },
      { type: "DWG", fromProductData: "DWGFrontView", angleView: "front" },
      { type: "DXF", fromProductData: "DXFFrontView", angleView: "front" },
      { type: "DWG", fromProductData: "DWGSideView", angleView: "side" },
      { type: "DXF", fromProductData: "DXFSideView", angleView: "side" },
    ],
    threeDimension: [
      { type: "DWG", fromProductData: "3DDWGSymbol" },
      { type: "DXF", fromProductData: "3DDXFSymbol" },
      { type: "3DS", fromProductData: "3D3DS" },
      { type: "OBJ", fromProductData: "3DOBJ" },
      { type: "SKP", fromProductData: "3DSketchup" },
    ],
    bim: [{ type: "RFA", fromProductData: "3DRevit" }],
    cutout: [{ type: "DXF", fromProductData: "CutOutDXF" }],
  }
  const [isExpanded, setIsExpanded] = useState(defaultExpand)

  const [currentSku, setCurrentSku] = useState(productSku)

  const dimensionsData = getDimensionData(dimensionData)

  useEffect(() => {
    if (productSku !== "" && currentSku !== productSku) {
      setCurrentSku(productSku)
      setTimeout(() => {
        setIsExpanded(defaultExpand)
      }, 500)
    }
  }, [productSku])

  const organizeData = (data, name, placeHolder, type) =>
    data.map((item, i) => {
      let obj = {
        title: name
          ? name[i]
          : `${placeHolder} ${data.length > 1 ? i + 1 : ""}`,
      }
      if (type === "part") {
        obj = { ...obj, id: item }
      } else {
        obj = { ...obj, type, url: item }
      }
      return obj
    })

  Object.keys(designFileType).forEach(fileType => {
    designFileType[fileType] &&
      designFileType[fileType].forEach(file => {
        if (
          productData[
            `ProductResource.${file.fromProductData}.resourceFullWebURL_ss`
          ]
        ) {
          if (fileType === "twoDimension") {
            designFiles[fileType][file.angleView].push({
              type: file.type,
              url: productData[
                `ProductResource.${file.fromProductData}.resourceFullWebURL_ss`
              ][0],
            })
          } else {
            designFiles[fileType].push({
              type: file.type,
              url: productData[
                `ProductResource.${file.fromProductData}.resourceFullWebURL_ss`
              ][0],
            })
          }
        }
      })
  })

  const designFilesLength =
    designFiles.twoDimension.plan.length +
    designFiles.twoDimension.front.length +
    designFiles.twoDimension.side.length +
    designFiles.threeDimension.length +
    designFiles.bim.length +
    designFiles.cutout.length

  const getListValue = (arrayVal, stringVal) => {
    if (productData[arrayVal]) {
      return productData[arrayVal]
    } else if (productData[stringVal]) {
      return [productData[stringVal]]
    } else {
      return []
    }
  }

  const featuresData = getListValue(
    "ProductWebFeatures_ss",
    "ProductWebFeatures_s"
  )

  const techData = getListValue(
    "ProductWebTechnology_ss",
    "ProductWebTechnology_s"
  )
  const webmaterialData = getListValue(
    "ProductWebMaterial_ss",
    "ProductWebMaterial_s"
  )
  const webInstallationData = getListValue(
    "ProductWebInstallation_ss",
    "ProductWebInstallation_s"
  )
  const prop65WarningData = getListValue(
    "ProductCaliforniaProp65WarningDisclaimer_ss",
    "ProductCaliforniaProp65WarningDisclaimer_s"
  )
  const webRebatesData = getListValue(
    "ProductWebRebates_ss",
    "ProductWebRebates_s"
  )
  const webHydrotherapyData = getListValue(
    "ProductWebHydrotherapy_ss",
    "ProductWebHydrotherapy_s"
  )
  const badges = getListValue("ProductBadgeInfo_ss", "ProductBadgeInfo_s")
  // check for technical files
  if (productData["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"]) {
    techFiles.push(
      ...organizeData(
        productData["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"],
        productData["ProductResource.SpecPDFFileName.resourceTitle_ss"],
        productAccordionText.specsSheet,
        "PDF"
      )
    )
  }
  if (productData["ProductResource.EnvironProdDecl.resourceFullWebURL_ss"]) {
    techFiles.push(
      ...organizeData(
        productData["ProductResource.EnvironProdDecl.resourceFullWebURL_ss"],
        productData["ProductResource.EnvironProdDecl.resourceTitle_ss"],
        productAccordionText.envDeclaration,
        "PDF"
      )
    )
  }
  const specDataLength =
    techData.length +
    webmaterialData.length +
    webInstallationData.length +
    prop65WarningData.length +
    webRebatesData.length +
    webHydrotherapyData.length +
    techFiles.length
  const specsDetails = [
    { specTitle: productAccordionText?.technologies, specList: techData },
    {
      specTitle: productAccordionText?.hydrotherapy,
      specList: webHydrotherapyData,
    },
    { specTitle: productAccordionText?.material, specList: webmaterialData },
    { specTitle: productAccordionText?.rebates, specList: webRebatesData },
    {
      specTitle: productAccordionText?.installation,
      specList: webInstallationData,
    },
  ]

  if (!disableEcommerce) {
    specsDetails.push({
      specTitle: productAccordionText?.props65Warning,
      specList: prop65WarningData,
    })
  }

  // check for installation & support files
  if (
    productData[
      "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"
    ]
  ) {
    installFiles.guides.installationGuides = organizeData(
      productData[
        "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"
      ],
      productData["ProductResource.InstallationWithoutSPPDF.resourceTitle_ss"],
      productAccordionText.installationGuide,
      "PDF"
    )
  }
  if (productData["ProductResource.HomeownersGuide.resourceFullWebURL_ss"]) {
    installFiles.guides.supportGuides = organizeData(
      productData["ProductResource.HomeownersGuide.resourceFullWebURL_ss"],
      productData["ProductResource.HomeownersGuide.resourceTitle_ss"],
      productAccordionText.homeOwnerGuide,
      "PDF"
    )
  }
  if (productData["ProductResource.YouTubeInstallVideo.resourceName_ss"]) {
    installFiles.videos = organizeData(
      productData["ProductResource.YouTubeInstallVideo.resourceName_ss"],
      productData["ProductResource.YouTubeInstallVideo.resourceTitle_ss"],
      productAccordionText.installationVideo,
      "part"
    )
  }

  if (productData["ProductResource.InteractiveSVG.resourceName_ss"]) {
    installFiles.partsLinks = organizeData(
      productData["ProductResource.InteractiveSVG.resourceName_ss"],
      productData["ProductResource.InteractiveSVG.resourceTitle_ss"],
      productAccordionText.partsDiagram,
      "part"
    )
  }

  if (productData["ProductResource.PartsPDFFileName.resourceFullWebURL_ss"]) {
    installFiles.pdfPartsLinks = organizeData(
      productData["ProductResource.PartsPDFFileName.resourceFullWebURL_ss"],
      productData["ProductResource.PartsPDFFileName.resourceTitle_ss"],
      productAccordionText.partsDiagram,
      "part"
    )
  }
  // Get support pages links from content fragment

  installFiles.supportLinks = installationSupportLinks?.length
    ? installationSupportLinks
    : []

  const installationFilesLength =
    installFiles.guides.installationGuides.length +
    installFiles.guides.supportGuides.length +
    installFiles.partsLinks.length +
    installFiles.videos.length

  let listValue = [
    "Features",
    "Dimensions",
    "Specs",
    "Installation & Support",
    "Design Files",
  ]
  if (persona === "TVS" || persona === "TPR") {
    listValue = [
      "Features",
      "Dimensions",
      "Specs",
      "Design Files",
      "Installation & Support",
    ]
  } else if (accordionList.length > 0) {
    listValue = accordionList.map(obj => decodeHtmlCharacters(obj?.value ?? ""))
  }
  const isInstallService = installationDataFromProp.filter(
    obj => productServices && productServices.includes(obj.sku)
  )
  const isDesignService = designServiceDataFromProp.filter(obj =>
    obj.productType.includes(productType)
  )
  const {
    feature,
    dimensions,
    specs,
    designFile,
    installationSupport,
    addOnService,
  } = isExpanded

  const watersense =
    badges.length &&
    badges.map((badge = "") => {
      const watersenseList = badge.split("|")
      return watersenseList[2] || []
    })

  const featrsData = {
    isExpanded,
    featuresData,
    productAccordionText,
    watersense,
  }

  const specsData = {
    techFiles,
    specsDetails,
    productAccordionText,
    productInfo,
  }

  const componentList = {
    Features: {
      element: <Features data={featrsData} />,
      title: productAccordionText.features,
      isExpanded: isExpanded.feature,
      keyValue: "feature",
      showAccordion: featuresData.length > 0,
      analyticData: accordianAnalyticsData(
        productAccordionText.features,
        isExpanded.feature
      ),
      isOpen: feature,
    },
    Dimensions: {
      element: (
        <RowData
          data={dimensionsData?.dimensions}
          accordionType={"dimensions"}
          productInfo={productInfo}
          config={config}
        />
      ),
      title: productAccordionText.dimensions,
      isExpanded: isExpanded.dimensions,
      keyValue: "dimensions",
      showAccordion:
        dimensionsData && dimensionsData?.enabled && dimensionsData?.dimensions,
      analyticData: accordianAnalyticsData("Dimensions", isExpanded.dimensions),
      isOpen: dimensions,
    },
    Specs: {
      element: (
        <Specs
          data={specsData}
          dimensionsData={dimensionsData?.specifications}
          config={config}
        />
      ),
      title: productAccordionText.specs,
      isExpanded: isExpanded.specs,
      keyValue: "specs",
      showAccordion: specDataLength > 0,
      analyticData: accordianAnalyticsData(
        productAccordionText.specs,
        isExpanded.specs
      ),
      isOpen: specs,
    },
    "Design Files": {
      element: (
        <DesignFiles
          files={designFiles}
          staticTexts={productAccordionText}
          productInfo={productInfo}
          sku={productSku}
        />
      ),
      title: productAccordionText.designFiles,
      isExpanded: isExpanded.designFile,
      showAccordion: designFilesLength > 0,
      keyValue: "designFile",
      analyticData: accordianAnalyticsData(
        productAccordionText.designFiles,
        isExpanded.designFile
      ),
      isOpen: designFile,
    },
    "Installation & Support": {
      element: (
        <InstallationSupport
          files={installFiles}
          staticTexts={productAccordionText}
          productInfo={productInfo}
          sku
          productSku
          svgFileMap={installFiles.partsLinks}
        />
      ),
      title: productAccordionText.installationSupport,
      isExpanded: isExpanded.installationSupport,
      showAccordion: installationFilesLength > 0,
      keyValue: "installationSupport",
      analyticData: accordianAnalyticsData(
        productAccordionText.installationSupport,
        isExpanded.installationSupport
      ),
      isOpen: installationSupport,
    },
    "Available Services": {
      element: <AddOnService {...props} />,
      title: productAccordionText.addOnServices,
      isExpanded: isExpanded.addOnService,
      showAccordion:
        !isDiscontinued &&
        !disableEcommerce &&
        (isInstallService.length > 0 || isDesignService.length > 0) &&
        !isProjectPack,
      keyValue: "addOnService",
      analyticData: accordianAnalyticsData(
        productAccordionText.addOnServices,
        isExpanded.addOnService
      ),
      isOpen: addOnService,
    },
  }

  const setAccordianState = (type, isOpen) => {
    if (!isOpen) {
      setTimeout(() => {
        setIsExpanded({ ...isExpanded, [type]: isOpen })
      }, 500)
    } else {
      setIsExpanded({ ...isExpanded, [type]: isOpen })
    }
  }

  const handleAccordionAnalytics = (type, isExpanded) => {
    if (typeof window !== "undefined") {
      const kohlerDatalayer = window.kohler.datalayer
      kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
        eventMetaData: {
          experience: "pdp",
          eventType: "AccordianAnalytics",
          params: {
            type,
            isExpanded,
            needsJSON: true,
          },
        },
      })
    }
  }

  return (
    <div
      className={`${accordionStyles.accordionWrapper} ${styles.productAccordionListWrapper}`}
    >
      {Object.keys(productData).length > 0 && (
        <div className={`pdp-support-files__container product-specifications`}>
          {listValue.map(list => {
            if (
              list === "Dimensions" &&
              !dimensionsData?.dimensions?.filter(d => d.value).length
            ) {
              return null
            }
            return componentList[list]?.showAccordion ? (
              <ProductAccordion
                title={componentList[list].title}
                key={componentList[list].keyValue}
                isOpen={componentList[list]?.isOpen}
                showOnPrint={list === "Features" || list === "Specs"}
                handleOpen={() => {
                  setAccordianState(componentList[list].keyValue, true)
                  handleAccordionAnalytics(
                    componentList[list].title,
                    componentList[list]?.isOpen
                  )
                }}
                handleClose={() => {
                  setAccordianState(componentList[list].keyValue, false)
                  handleAccordionAnalytics(
                    componentList[list].title,
                    componentList[list]?.isOpen
                  )
                }}
                analyticTitleData={componentList[list].analyticData}
                analyticTitleCustomData={productInfo}
              >
                {componentList[list].element}
              </ProductAccordion>
            ) : null
          })}
        </div>
      )}
    </div>
  )
  //   }
}

export default ProductAccordionList
